<template>
    <div id="topMostElement" class="providerSection">
        <div :style="`z-index: 9999; position: absolute; right: 7%; top: ${screen_width >= 1265 ? '13px' : '80px;'}`">
            <v-alert
                v-model="notif.show"
                transition="scroll-x-reverse-transition"
                :dismissible="notif.dismissible"
                :type="notif.type"
                :color="notif.color"
            >
                {{ notif.msg }}
            </v-alert>
            <v-alert
                v-model="notif.showWarn"
                transition="scroll-x-reverse-transition"
                dismissible
                type="warning"
                color="warning"
            >
                {{ generateReportData && generateReportData.data && generateReportData.data.warn }}
            </v-alert>
        </div>
        <v-btn
            v-if="screen_width <= 630"
            icon
            class="black--text"
            @click="valid = false"
        >
            <v-icon
                dark
                left
            >
                {{ mdiArrowLeft }}
            </v-icon>
        </v-btn>
        <h1>
            <v-icon
                v-if="screen_width > 520"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiBook }}
            </v-icon>Ledgers 
        </h1>
        <div class="docInfoBody">
            <LedgerTable :provider-id="hosp">
                <v-autocomplete
                    v-model.trim="hosp"
                    outlined
                    hide-details
                    dense
                    color="teal"
                    :auto-select-first="true"
                    item-text="hosp_name"
                    :items="hospItems"
                    return-object
                    label="Hospital or Clinic Name"
                />
                <v-spacer />
                <v-btn
                    style="height: 42px;"
                    color="teal"
                    class="white--text"
                    @click="show=true"
                >
                    <v-icon>{{ mdiBookCog }}</v-icon>&nbsp;generate ledger
                </v-btn>
            </LedgerTable>
        </div>
        <GenerateLedger
            :show="show"
            :hosp="hosp"
            @closeDialog="show = false"
            @generateNotif="generateNotif"
        />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import GenerateLedger from './GenerateLedger.vue'
import LedgerTable from './LedgerTable.vue'
import { mdiArrowLeft, mdiBook, mdiBookCog } from '@mdi/js'
export default {
    components: {
        GenerateLedger,
        LedgerTable
    },
    data: ()=>({
        mdiArrowLeft, mdiBook, mdiBookCog,
        hosp: null,
        hospItems: null,
        providerId: null,
        notif: {
            type: 'error',
            color: 'error',
            msg: null,
            show: false,
            data: null,
            dismissible: false,
            showWarn: false
        },
        show: false,
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['generateReportData', 'docInfoData', 'getLinkedProvidersData'])
    },
    watch: {
        notif: {
            handler(newVal) {
                if (newVal.show) {
                    if (newVal.timeout !== 0) {
                        setTimeout(() => {
                            this.notif.show = false
                        }, newVal.timeout)
                    }
                }
            },
            deep: true
        },
        async hosp(newVal) {
            if (newVal) {
                const PROVIDER_ID = newVal.hosp_msu_code
                await this.getProviderHistory({ PROVIDER_ID })
            }
        },
        docInfoData(newVal) {
            if (newVal) {
                this.hosp      = {
                    hosp_name: newVal.NAME,
                    hosp_msu_code: this.$cookies.get('provider_id')
                }
                if (this.hospItems === null) this.hospItems = [this.hosp]
            }
        },
        getLinkedProvidersData(newVal) {
            if (newVal && newVal.data) this.hospItems = [this.hosp, ...newVal.data]
        }
    },
    async created(){
        const PROVIDER_ID = this.$cookies.get('provider_id')
        // await this.getProviderHistory({ PROVIDER_ID })
        await this.getProviderInfo({ PROVIDER_ID })
        await this.getLinkedProviders({ MSU_C: PROVIDER_ID })
    },
    mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['getProviderHistory', 'getProviderInfo', 'getLinkedProviders']),
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        },
        generateNotif(val) {
            this.notif = val
        }
    }
}
</script>

<style scoped>
h1 {
    position: relative;
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.docInfoBody {
    margin-top: 5%;
}
    .hospContainer {
        margin-bottom: 15px;
        padding: 15px 15px 2px 15px;
    }
.providerSection {
    position: relative;
    padding: 10px 7.5% 0 7.5%;
}
@media (max-width: 380px) {
  .providerSection {
    position: relative;
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (max-width: 599px) {
  .providerSection {
    position: relative;
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 599px) and (max-width: 1264px) {
  .providerSection {
    position: relative;
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 1264px) {
  .providerSection {
    position: relative;
    padding: 10px 7.5% 0 7.5%;
  }
}
</style>
